// Album open deep-link path prefix. Pinned to
// common-contracts/album_open_link.json (see albumOpenLink.test.ts). The
// webclient serves /<prefix>/:code; print-service builds the matching URL.
export const OPEN_LINK_PATH_PREFIX = 'open';
